import isunsin from '../assets/layout/images/project_bms_isunsin.png'
import incheon from '../assets/layout/images/project_bms_incheon.png'
import hankang from '../assets/layout/images/project_bms_hankang.png'
import eul_young from '../assets/layout/images/project_bms_eul_young.png'
import worldcup from '../assets/layout/images/project_bms_worldcup.png'
import tablet from '../assets/layout/images/project_bms_tablet.png'


const Project_bms_case = () => {


  return(
    <>
      <div className="container-lg" style={{ maxWidth: 1200 }}>
        <div className="detail-item">
          <h1 className="item-title" style={{marginBottom: "20px"}}>교량 계측 시스템 구축 사례​</h1>
          <div className="item-desc" style={{marginBottom: "36px"}}>
            아미소프트는 교량 계측 및 관리 시스템을 다양한 정부 기관과 협력하여 구축·운영해 왔으며, 다년간 축적된 노하우와 현장에서 검증된 안정성으로 파트너들로부터 높은 신뢰와 만족을 받고 있습니다​
          </div>
          <figure className="item-figure-bms" >
            <img 
              className="item-img" 
              src={isunsin} 
              alt="이순신대교 통합 계측 시스템"
            />
            <figcaption className="item-caption">이순신대교 통합 계측 시스템</figcaption>
          </figure>
          <figure className="item-figure-bms" >
            <img 
              className="item-img" 
              src={incheon} 
              alt="인천대교 통합 계측 시스템"
            />
            <figcaption className="item-caption">인천대교 통합 계측 시스템</figcaption>
          </figure>
          <figure className="item-figure-bms" >
            <img 
              className="item-img" 
              src={hankang} 
              alt="한강 온라인 안전감시 시스템"
            />
            <figcaption className="item-caption">한강 온라인 안전감시 시스템</figcaption>
          </figure>
          <figure className="item-figure-bms" >
            <img 
              className="item-img" 
              src={eul_young} 
              alt="을숙대교 영흥대교 통합 계측 시스템"
            />
            <div className="item-caption-group">
              <figcaption className="item-caption">을숙대교 통합 계측 시스템</figcaption>
              <figcaption className="item-caption">영흥대교 통합 계측 시스템</figcaption>
            </div>
          </figure>
        </div>

        <div className="detail-item">
          <h1 className="item-title" style={{marginBottom: "20px"}}>케이블 구조 계측​</h1>
          <div className="item-desc">
            케이블 구조계측 분야에서 오랜 경험과 검증된 기술을 바탕으로, 교량과 대형 구조물이 안전하게 운영될 수 있도록 안정적인 솔루션을 제공합니다.
          </div>
          <figure className="item-figure-bms" >
            <img 
              className="item-img" 
              src={worldcup} 
              alt="서울 월드컵 경기장 지붕 계측 시스템"
            />
            <figcaption className="item-caption">서울 월드컵 경기장 지붕 계측 시스템</figcaption>
          </figure>
        </div>

        <div className="detail-item">
          <h1 className="item-title" style={{marginBottom: "20px"}}>태블릿 기반 손상이력 관리​</h1>
          <div className="item-desc">
            교량의 손상이력을 태블릿 애플리케이션으로 현장에서 직접 기록하고 관리할 수 있도록 합니다. PC뿐만 아니라 현장에서 태블릿으로 바로 활용할 수 있어, 보다 효율적이고 정확한 관리가 가능합니다.​
          </div>
          <figure className="item-figure-bms" >
            <img 
              className="item-img" 
              src={tablet} 
              alt="BMS 태블릿 어플리케이션"
            />
            <figcaption className="item-caption">BMS 태블릿 어플리케이션</figcaption>
          </figure>
        </div>

      </div>
    </>
  )
};

export default Project_bms_case;